// Free wellness guide popup: shows once the visitor has spent `delay` seconds on the site (counted across
// pages), then stays away for `days` days after it is closed or used. Skipped when the guide is in the cart.

const GUIDE_SEEN_KEY = 'haya-guide-seen';
const GUIDE_START_KEY = 'haya-guide-start';
const DAY_MS = 86400000;

// Storage can throw (private mode, blocked site data); the popup then simply follows the timer
const storage = {
  get(area, key) {
    try {
      return window[area].getItem(key);
    } catch {
      return null;
    }
  },
  set(area, key, value) {
    try {
      window[area].setItem(key, value);
    } catch {}
  },
};

class HayaGuidePopup extends HTMLElement {
  connectedCallback() {
    this.card = this.querySelector('.haya-guide');
    const seen = Number(storage.get('localStorage', GUIDE_SEEN_KEY));
    if (seen && Date.now() - seen < Number(this.dataset.days) * DAY_MS) return;

    this.querySelector('[data-guide-close]').addEventListener('click', () => this.dismiss());
    this.querySelector('[data-guide-cta]').addEventListener('click', () => this.remember());
    this.addEventListener('keydown', (event) => event.key === 'Escape' && this.dismiss());
    this.timer = setTimeout(() => this.open(), this.remainingDelay());
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  // Time on site carries over between pages within a browsing session
  remainingDelay() {
    let start = Number(storage.get('sessionStorage', GUIDE_START_KEY));
    if (!start) {
      start = Date.now();
      storage.set('sessionStorage', GUIDE_START_KEY, String(start));
    }
    return Math.max(0, Number(this.dataset.delay) * 1000 - (Date.now() - start));
  }

  async open() {
    if (document.querySelector('dialog[open]') || (await this.inCart())) return;
    this.card.hidden = false;
    requestAnimationFrame(() => this.card.classList.add('is-open'));
  }

  async inCart() {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      return cart.items.some((item) => item.product_id === Number(this.dataset.productId));
    } catch (error) {
      console.error('Guide popup: could not read cart', error);
      return false;
    }
  }

  remember() {
    storage.set('localStorage', GUIDE_SEEN_KEY, String(Date.now()));
  }

  dismiss() {
    this.remember();
    this.card.classList.remove('is-open');
    setTimeout(() => (this.card.hidden = true), 300);
  }
}

if (!customElements.get('haya-guide-popup')) customElements.define('haya-guide-popup', HayaGuidePopup);
